import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API } from './constants';
import { PaginationInput } from '../store/types';

export type CreateBankBeneficiaryInput = {
  companyId: string;
  bankId: string;
  accountNumber: string;
  currencyId: string;
  alias: string;
  iban?: string;
};

export type GetBankBeneficiariesDto = {
  search?: string;
  companyId?: string;
  bankId?: string;
	currencyId?: string;
	accountNumber: string;
};

@Injectable({ providedIn: 'root' })
export class BankBeneficiaryService extends ApiService {
  getBankBeneficiaries(pagination: PaginationInput, dto: GetBankBeneficiariesDto) {
    return this.post(`${API.getBankBeneficiaries}`, { body: { pagination, dto } });
  }

  createBankBeneficiary(beneficiaryData: CreateBankBeneficiaryInput) {
    return this.post<any>(`${API.createBankBeneficiary}`, { body: beneficiaryData });
  }

  deleteBankBeneficiary(beneficiaryId: string) {
    return this.delete<any>(`${API.deleteBankBeneficiary}/${beneficiaryId}`);
  }
}
